import Icon from "@gc-npm/components.icon-glyph";
import styles from "./style";
import Spinner from "@gc-npm/components.spin";
import getColor from "@gc-npm/utils.enums.colors";
import { useSelector } from "react-redux";
import { getFullUrl } from "@/utils/htmlUtils";
import { generateQueryString } from "@/utils/normalizers/product";
import { useRef, useState } from "react";
import { useRouter } from "next/router";

const OldSearchBox = ({
    placeholder,
    ariaLabel,
    id,
    onSubmit,
    onFocus,
    onBlur
}) => {
    const {
        searcherQuery,
        selectedFilters,
        sort,
        id: idRoute,
    } = useSelector((state) => state.devicesList);
    const router = useRouter();
    const { query: routerQuery } = router;
    const [inputValue, setInputValue] = useState(searcherQuery);
    const inputRef = useRef();


    const handleChange = (event) => {
        setInputValue(event.currentTarget.value);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        inputRef.current.blur();
        onSubmit(inputValue);
    };

    const ClearQuery = () => {
        const selectedFiltersNew = { ...selectedFilters };

        selectedFiltersNew.query = "";
        selectedFiltersNew.id = idRoute;
        const url = getFullUrl(`/${idRoute}?sort=${sort}&${generateQueryString(selectedFiltersNew)
            }`, routerQuery);
        router.push(url, undefined, { shallow: true });
        setInputValue("");
    };

    const handleFocus = async () => {
        onFocus();
    };

    const handleBlur = () => {
        onBlur();
    };

    return (
        <>
            <form
                className="searcher-box"
                onSubmit={handleSubmit}
                onMouseDown={onFocus}
            >
                <div className="search-icon-container" aria-hidden="true">
                    <Icon id="buscar-m" height={22} color="GREY_600" alt="" />
                </div>
                <input
                    className="searcher-input"
                    value={inputValue}
                    type="search"
                    name="buscador"
                    id={id}
                    aria-label={ariaLabel}
                    onChange={handleChange}
                    placeholder={placeholder}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    autoComplete="off"
                    ref={inputRef}
                />
                {false && loading && (
                    <div className="iconContainerLoading" aria-hidden="true">
                        <Spinner
                            size="small"
                            operation="loading"
                            fillColor={getColor("GREY_600")}
                            strokeColor={getColor("GREY_600")}
                        />
                    </div>
                )}
                {searcherQuery !== "" && (
                    <div className="close-icon-container" onClick={ClearQuery} aria-label="Cerrar">
                        <div aria-hidden="true">
                            <Icon id="cerrar-m" height={15} color="grey7" />
                        </div>
                    </div>
                )}
                <style jsx>{styles}</style>
            </form >
        </>
    );
};

export default OldSearchBox;
